import { useEffect, useState } from "react";
import { Clover } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

export const LuckyHourBanner = ({ compact = false }) => {
  const [lh, setLh] = useState(null);
  useEffect(() => {
    const pull = () => api.get("/player/lucky-hour").then((r) => setLh(r.data)).catch(() => {});
    pull();
    const t = setInterval(pull, 60000);
    return () => clearInterval(t);
  }, []);
  if (!lh) return null;
  return (
    <div data-testid="lucky-hour-banner"
      className={`rounded-2xl border px-4 ${compact ? "py-2" : "py-3"} flex items-center gap-3 ${lh.active ? "border-[#3DDC84]/60 bg-[#3DDC84]/10" : "border-gold/30 bg-black/40"}`}>
      <Clover className={`h-5 w-5 shrink-0 ${lh.active ? "text-[#3DDC84] animate-pulse" : "text-gold"}`} />
      <div className="text-xs sm:text-sm">
        {lh.active ? (
          <span><b className="text-[#3DDC84] font-casino tracking-wider">LUCKY HOUR IS LIVE</b> <span className="text-white/70">· until {fmt(lh.ends_at)} — the lobby is buzzing</span></span>
        ) : (
          <span className="text-white/70">Today's <b className="text-gold font-casino tracking-wider">Lucky Hour</b> starts at {fmt(lh.starts_at)} (your time)</span>
        )}
      </div>
    </div>
  );
};
